import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HrmEmployeeService {
  constructor(private api: ApiService) {}

  // ── Core Employee CRUD ────────────────────────────────────────────────────
  createEmployee(data: any): Observable<any> {
    return this.api.post(environment.createEmployee, data);
  }
  updateEmployee(data: any): Observable<any> {
    return this.api.post(environment.updateEmployee, data);
  }
  getAllEmployees(data: any): Observable<any> {
    return this.api.post(environment.getAllEmployees, data);
  }
  getEmployeeById(data: any): Observable<any> {
    return this.api.post(environment.getEmployeeById, data);
  }
  deleteEmployee(data: any): Observable<any> {
    return this.api.post(environment.deleteEmployee, data);
  }
  updateEmployeeStatus(data: any): Observable<any> {
    return this.api.post(environment.updateEmployeeStatus, data);
  }
  uploadEmployeeDocument(data: any): Observable<any> {
    return this.api.post(environment.uploadEmployeeDocument, data);
  }
  getEmployeeDocuments(data: any): Observable<any> {
    return this.api.post(environment.getEmployeeDocuments, data);
  }

  // ── Full Profile ──────────────────────────────────────────────────────────
  getFullEmployeeProfile(data: any): Observable<any> {
    return this.api.post(environment.getFullEmployeeProfile, data);
  }

  // ── Employee Contacts (prefixed to avoid conflict with CRM contacts module) ─
  addEmpContact(data: any): Observable<any> { return this.api.post(environment.addEmpContact, data); }
  updateEmpContact(data: any): Observable<any> { return this.api.post(environment.updateEmpContact, data); }
  deleteEmpContact(data: any): Observable<any> { return this.api.post(environment.deleteEmpContact, data); }
  getEmpContacts(data: any): Observable<any> { return this.api.post(environment.getEmpContacts, data); }

  // ── Addresses ─────────────────────────────────────────────────────────────
  addAddress(data: any): Observable<any> { return this.api.post(environment.addAddress, data); }
  updateAddress(data: any): Observable<any> { return this.api.post(environment.updateAddress, data); }
  deleteAddress(data: any): Observable<any> { return this.api.post(environment.deleteAddress, data); }
  getAddresses(data: any): Observable<any> { return this.api.post(environment.getAddresses, data); }

  // ── Family Members ────────────────────────────────────────────────────────
  addFamilyMember(data: any): Observable<any> { return this.api.post(environment.addFamilyMember, data); }
  updateFamilyMember(data: any): Observable<any> { return this.api.post(environment.updateFamilyMember, data); }
  deleteFamilyMember(data: any): Observable<any> { return this.api.post(environment.deleteFamilyMember, data); }
  getFamilyMembers(data: any): Observable<any> { return this.api.post(environment.getFamilyMembers, data); }

  // ── Education ─────────────────────────────────────────────────────────────
  addEducation(data: any): Observable<any> { return this.api.post(environment.addEducation, data); }
  updateEducation(data: any): Observable<any> { return this.api.post(environment.updateEducation, data); }
  deleteEducation(data: any): Observable<any> { return this.api.post(environment.deleteEducation, data); }
  getEducation(data: any): Observable<any> { return this.api.post(environment.getEducation, data); }

  // ── Experience ────────────────────────────────────────────────────────────
  addExperience(data: any): Observable<any> { return this.api.post(environment.addExperience, data); }
  updateExperience(data: any): Observable<any> { return this.api.post(environment.updateExperience, data); }
  deleteExperience(data: any): Observable<any> { return this.api.post(environment.deleteExperience, data); }
  getExperience(data: any): Observable<any> { return this.api.post(environment.getExperience, data); }

  // ── Skills ────────────────────────────────────────────────────────────────
  addSkill(data: any): Observable<any> { return this.api.post(environment.addSkill, data); }
  updateSkill(data: any): Observable<any> { return this.api.post(environment.updateSkill, data); }
  deleteSkill(data: any): Observable<any> { return this.api.post(environment.deleteSkill, data); }
  getSkills(data: any): Observable<any> { return this.api.post(environment.getSkills, data); }

  // ── Bank Details ──────────────────────────────────────────────────────────
  addBankDetail(data: any): Observable<any> { return this.api.post(environment.addBankDetail, data); }
  updateBankDetail(data: any): Observable<any> { return this.api.post(environment.updateBankDetail, data); }
  deleteBankDetail(data: any): Observable<any> { return this.api.post(environment.deleteBankDetail, data); }
  getBankDetails(data: any): Observable<any> { return this.api.post(environment.getBankDetails, data); }

  // ── Employee Documents (dedicated table) ──────────────────────────────────
  addEmpDocument(data: any): Observable<any> { return this.api.post(environment.addEmpDocument, data); }
  updateEmpDocument(data: any): Observable<any> { return this.api.post(environment.updateEmpDocument, data); }
  deleteEmpDocument(data: any): Observable<any> { return this.api.post(environment.deleteEmpDocument, data); }
  getEmpDocuments(data: any): Observable<any> { return this.api.post(environment.getEmpDocuments, data); }

  // ── Assets ────────────────────────────────────────────────────────────────
  addAsset(data: any): Observable<any> { return this.api.post(environment.addAsset, data); }
  updateAsset(data: any): Observable<any> { return this.api.post(environment.updateAsset, data); }
  deleteAsset(data: any): Observable<any> { return this.api.post(environment.deleteAsset, data); }
  // ── Enrollment Check ─────────────────────────────────────────────────────
  checkEmployeeEnrollment(data: any): Observable<any> { return this.api.post(environment.checkEmployeeEnrollment, data); }
}
